import React, {useEffect, useState} from 'react';
import './HeaderProgressBar.sass';

const HeaderProgressBar = ({data, status}) => {

    const barWidth = 350

    const calculateWidth = (modIndex) => {
        let pct = "0%"
        let pages = status[modIndex];
        if(!pages) return 0
        let completeCount = 0
        pages.map((p)=>{
            if(p===2) ++completeCount
        })
        pct = (completeCount/pages.length)*100
        
        return String(pct)+"%"
    }


    return (
        <div className="HeaderProgressBar"
             style={{
                 width: barWidth
             }}>
            {data &&
            data.map((m, index) => (
                <div className={"header-progressbar-section"}
                     style={{
                         width: barWidth / data.length
                     }}>
                    <div
                        style={{
                            height: "100%",
                            backgroundColor: m.color?m.color:"white",
                            width: calculateWidth(index)
                        }}/>
                </div>
            ))
            }
        </div>
    );
};

export default HeaderProgressBar;